var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 11a6.25 6.25 0 1 1 12.5 0 6.25 6.25 0 0 1-12.5 0ZM11 3.25a7.75 7.75 0 1 0 4.371 14.15.745.745 0 0 0 .17.261l3.94 3.94a.75.75 0 0 0 1.06-1.061l-3.94-3.94a.754.754 0 0 0-.134-.107A7.75 7.75 0 0 0 11 3.25Z",
    clipRule: "evenodd"
  })));
};
export default SvgZoom;